<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="page-main" v-loading="listLoading">
      <div v-show="steps != 'pingjia'" class="panel-heading">
        <el-button plain icon="el-icon-arrow-left" @click="backToGongdan"></el-button>
        <span class="se-panel-title z-padding-left-5-precent ver-sub">工单详情</span>
      </div>
      <div v-show="steps === 'pingjia'" class="panel-heading">
        <el-button plain icon="el-icon-arrow-left" @click="backToContent"></el-button>
        <span class="se-panel-title z-padding-left-5-precent ver-sub">工单服务评价</span>
      </div>
      <div v-show="steps != 'pingjia'" class="step-bar-quadra step-bar-outer clearfix z-textAlign-center margin-v-20">
        <div :class="{'step--current':steps === 'first','step--dealing':steps === 'first'}" class="step-bar step-bar-begin">
          <div class="step-colored">
            <span class="step-prefix"></span>
            <!--<span class="hide">等待客服接单</span>-->
            <span>工单受理</span>
          </div>
          <span class="step-arrow-right"></span>
        </div>
        <div :class="{'step--current':steps === 'second','step--dealing':steps === 'second'}" class="step-bar step-bar-center">
          <span class="step-arrow-left"></span>
          <div class="step-colored">
            <span class="step-prefix"></span>
            <!--<span class="hide">未开始处理</span>-->
            <span>工单处理中</span>
          </div>
          <span class="step-arrow-right"></span>
        </div>
        <div :class="{'step--current':steps === 'three','step--dealing':steps === 'three'}" class="step-bar step-bar-center">
          <span class="step-arrow-left"></span>
          <div class="step-colored">
            <span class="step-prefix"></span>
            <!--<span class="hide">未确认</span>-->
            <span>工单完成确认</span>
          </div>
          <span class="step-arrow-right"></span>
        </div>
        <div :class="{'step--current':steps === 'four','step--dealing':steps === 'four'}" class="step-bar step-bar-end">
          <span class="step-arrow-left"></span>
          <div class="step-colored">
            <span class="step-prefix"></span>
            <!--<span class="hide">未评价</span>-->
            <span>用户评价</span>
          </div>
        </div>
      </div>
      <!--工单详情-->
      <div v-show="steps != 'pingjia'" class="detail-panel margin-bottom-20">
        <div class="clearfix">
          <div class="pull-left detail-item">
            <div class="pull-left detail-item z-oneline-overflow-hidden" style="padding-right: 12%;">
              <span class="z-color-muted">工单内容：</span>
              {{content.title}}
            </div>
            <span class="z-color-muted">工单编号：</span>
            {{gongdan.id}}
          </div>
          <div class="pull-left detail-item">
            <div class="pull-left">
              <span class="z-color-muted">提交时间：</span>
              {{content.time}}
            </div>
            <div v-if="this.steps === 'four'" class="pull-right detail-item">
              <el-rate
                v-model="content.rate"
                disabled
                disabled-void-color="#99A9BF">
              </el-rate>
            </div>
          </div>
        </div>
        <!-- <div class="clearfix detail-tier">
                      <span class="text-muted">工单类别：</span>
                      网络类
                  </div> -->
        <div class="clearfix detail-tier">
          <div class="pull-left detail-item">
            <span class="z-color-muted">工单状态：</span>
            <span class="z-color-66-orange">
								{{content.state}}
							</span>
          </div>
          <div class="pull-left detail-item">
            <div class="pull-left detail-item">
            </div>
            <div v-if="this.steps === 'four'" class="pull-right detail-item z-oneline-overflow-hidden">
              <span class="pull-left z-color-muted">评价：</span>
              <el-tooltip :content="content.pingjia" placement="bottom" effect="light">
                <span>{{content.pingjia}}</span>
              </el-tooltip>
            </div>
          </div>
          <div class="pull-right">
            <el-button v-show="this.steps === 'first'" @click="dialogChoose = true">关闭工单</el-button>
            <el-button v-show="this.steps === 'three'" @click="GongdanPingjia">评价工单</el-button>
            &nbsp;
            <a @click="touSu" v-show="this.steps === 'three'" class="z-curPonit z-color-a a-underline-link">一键投诉</a>
          </div>
        </div>
      </div>
      <!--沟通记录-->
      <div v-show="steps != 'pingjia'" class="talk-container z-margin-bottom-15-precent">
        <div class="talk-container-head">
          沟通记录
          <!--<a href="#" class="pull-right hide">
            按时间顺序排列
            <i class="filter-icon"></i>
          </a>-->
        </div>
        <div class="talk-content">
          <!-- 对话列表 -->
          <div class="talk-record-box" id="talkRecordBox">
            <!-- 第一个为固定的用户对话记录 -->
            <div class="talk-item clearfix">
              <div class="talk-user-img user-record"></div>
              <div class="talk-problem">
                <h4>问题描述：</h4>
                <div class="talk-problem-text">
                  <div v-for="_item in content.title.split('\n')" class="talk-content-row">
                    {{_item}}
                  </div>
                </div>
                <div v-show="content.fujian_1" class="talk-attachments pull-left">
                  <a href="javascript:;" @click="LargeImg(content.fujian_1)">
                    <img :src="content.fujian_1" class="attachment-img">
                  </a>
                </div>
                <div v-show="content.fujian_2" class="talk-attachments pull-left">
                  <a href="javascript:;" @click="LargeImg(content.fujian_2)">
                    <img :src="content.fujian_2" class="attachment-img">
                  </a>
                </div>
                <div v-show="content.fujian_3" class="talk-attachments pull-left">
                  <a href="javascript:;" @click="LargeImg(content.fujian_3)">
                    <img :src="content.fujian_3" class="attachment-img">
                  </a>
                </div>
              </div>
              <div class="talk-time">2018-04-17 10:15:51</div>
            </div>

            <div v-for="item in reply_content" :class="{'staff-member':item.gd_reply_user}" class="talk-item clearfix">
              <div v-show="!item.gd_reply_user" class="talk-user-img user-record"></div>
              <div v-show="item.gd_reply_user" class="talk-user-img official-record"></div>
              <div class="talk-problem">
                <h4 v-show="!item.gd_reply_user">问题描述：</h4>
                <h4 v-show="item.gd_reply_user">售后答复：</h4>
                <div class="talk-problem-text">
                  <div v-for="option in item.gd_content.split('\n')" class="talk-content-row">
                    {{option}}
                  </div>
                </div>
                <div v-show="item.fujian_1" class="talk-attachments pull-left">
                  <a href="javascript:;" @click="LargeImg(item.fujian_1)">
                    <img :src="item.fujian_1" class="attachment-img">
                  </a>
                </div>
                <div v-show="item.fujian_2" class="talk-attachments pull-left">
                  <a href="javascript:;" @click="LargeImg(item.fujian_2)">
                    <img :src="item.fujian_2" class="attachment-img">
                  </a>
                </div>
                <div v-show="item.fujian_3" class="talk-attachments pull-left">
                  <a href="javascript:;" @click="LargeImg(item.fujian_3)">
                    <img :src="item.fujian_3" class="attachment-img">
                  </a>
                </div>
              </div>
              <div class="talk-time">{{item.gd_time}}</div>
            </div>
          </div>
        </div>
        <div v-show="this.steps === 'first'" class="talk-panel">

          <div class="talk-container-head margin-bottom-30">
            发表回复
          </div>

          <div>
								<span class="z-color-muted pull-left">
									问题描述：
								</span>
            <div class="textarea-container">
              <textarea v-model="reply" class="talk-textarea" name="content" rows="5" placeholder="请输入您的问题描述情况————"></textarea>
              <div class="textarea-desc">
                <span>请输入问题描述，限2000字</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="this.steps === 'first'" class="clearfix margin-bottom-20">
						<span class="z-color-muted pull-left">
							附件上传：
						</span>
        <div class="ub-box" style="padding-left: 10px;">
          <div class="ub-box">
            <div class="col-img-container">
                    <span class="col-img" v-show="imgnum == 0">
                      <img  src="../../assets/imgs/img3.png" alt="请上传现场图片" width="135" height="102">
                    </span>
              <span :class="{'attachment-uploading':imgnum == 1 && loadingImg,'attachment-done': dataUrl.length > 0}" class="col-img" v-show="imgnum>0">
                      <img  class="col-img-item" :src="dataUrl[0]" width="135" height="102"/>
                      <a class="delete-attachment default-transition z-textAlign-center" href="javascript:;" @click="delImg(0)">删除</a>
                    </span>
              <span :class="{'attachment-uploading':imgnum == 2 && loadingImg,'attachment-done': dataUrl.length > 1}" class="col-img" v-show="imgnum>1">
                      <img  class="col-img-item" :src="dataUrl[1]" width="135" height="102"/>
                      <a class="delete-attachment default-transition z-textAlign-center" href="javascript:;" @click="delImg(1)">删除</a>
                    </span>
              <span :class="{'attachment-uploading':imgnum == 3 && loadingImg,'attachment-done': dataUrl.length > 2}" class="col-img" v-show="imgnum>2">
                      <img class="col-img-item" :src="dataUrl[2]" width="135" height="102"/>
                      <a class="delete-attachment default-transition z-textAlign-center" href="javascript:;" @click="delImg(2)">删除</a>
                    </span>
            </div>
          </div>
          <div class="z-margin-left-15-precent" v-show="imgnum < 3">
            <p class="gff8 z-font-size-14">JPG或PNG格式</p>
            <p class="z-font-size-12 z-color-999 z-padding-bottom-5-precent">最多可上传3个附件
            </p>
            <label for="fileImg1" class="choose-file">上传附件</label>
            <input type="file" id="fileImg1" name="CertImg" @change="handleFileChange" ref="inputer" class="z-width-30-precent" style="visibility: hidden;">
          </div>
        </div>
      </div>
      <div v-show="this.steps === 'first'" class="z-margin-bottom-50-precent">
        <el-button v-show="reply === ''" type="primary" class="talk-btn" disabled>继续提问</el-button>
        <el-button v-show="reply != ''" type="primary" class="talk-btn" @click="submit">继续提问</el-button>
      </div>
      <el-form v-show="steps === 'pingjia'" :model="pingjiaForm" ref="pingjiaForm" label-width="180px" class="pingjia-form z-margin-top-20-precent" status-icon >
        <el-form-item label="工单编号：" prop="id">
          {{content.id}}
        </el-form-item>
        <el-form-item label="服务评分：" prop="xing">
          <el-rate v-model="pingjiaForm.rate" show-text :texts="['1分 [非常不满意]', '2分 [不满意]', '3分 [一般]', '4分 [满意]', '5分 [非常满意]']" text-color="red" style="padding-top: 5px;">
          </el-rate>
        </el-form-item>
        <el-form-item label="您的评价：" prop="content">
          <el-input type="textarea" :rows="4" placeholder="请填写您的评价" v-model="pingjiaForm.content"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button v-show="!pingjiaForm.rate || !pingjiaForm.content" type="primary" disabled>提交评价</el-button>
          <el-button v-show="pingjiaForm.rate && pingjiaForm.content" type="primary" @click="Pingjia" style="margin-left: 0">提交评价</el-button>
        </el-form-item>
      </el-form>
    </div>
    <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
    <el-dialog
      title=""
      :visible.sync="dialogShowImg"
      top="6%"
      :lock-scroll=false
      custom-class="show-img">
      <img width="100%" :src="showimgurl" alt="">
    </el-dialog>
    <el-dialog
      title="是否解决工单？"
      :visible.sync="dialogChoose"
      top="18.5%"
      width="375px"
      :lock-scroll=false
      :close-on-click-modal=false
      :close-on-press-escape=false
      custom-class="dialog">
      <el-radio v-model="radio" label="1">是</el-radio>
      <el-radio v-model="radio" label="0">否</el-radio>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="GongdanClose">确 定</el-button>
          <el-button @click="dialogChoose = false">取 消</el-button>
        </span>
    </el-dialog>
  </div>
</template>
<script>
  import { MessageBox } from 'element-ui';
  import gongdanService from 'business/gongdanService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import {mapGetters,mapActions} from 'vuex'
  export default {
    data () {
      return {
        dialogLoading:false,
        dialogShowImg:false,
        listLoading:false,
        dialogChoose:false,
        showimgurl:'',
        gongdan:{},
        steps:'first',
        content:{
          id:'',
          title:'',
          state:'',
          time:'',
          fujian_1:'',
          fujian_2:'',
          fujian_3:'',
          rate:0,
          pingjia:''
        },
        reply_content:[],
        reply:'',
        dataUrl:[],
        imgnum:0,
        loadingImg:false,
        pingjiaForm:{
          rate:null,
          content:''
        },
        radio:'1'
      }
    },
    components:{
      XdialogLoading,
    },
    props:{
      hide:Boolean
    },
    mounted() {
      this.config()
    },
    methods:{
      async config() {
        this.gongdan = {'id': this.$route.params.id }
        this.GongdanQuery()
      },
      async GongdanQuery() {
        this.listLoading = true
        let data = 'cmd=gd_list'+
          '&key_type=id'+
          '&keyword='+ this.gongdan.id
        let {vueData, state} = await gongdanService.transformToVue('gdInfo','POST',data)
        if(vueData.response == 200 ) {
          this.listLoading = false
          this.total = vueData.msg.allcount
          this.content.id = vueData.msg.content[0].id
          this.content.title = vueData.msg.content[0].gd_content
          this.content.time = vueData.msg.content[0].gd_time
          this.content.fujian_1 = vueData.msg.content[0].fujian_1
          this.content.fujian_2 = vueData.msg.content[0].fujian_2
          this.content.fujian_3 = vueData.msg.content[0].fujian_3
          this.content.rate = Number(vueData.msg.content[0].gd_pingjia)
          this.content.pingjia = vueData.msg.content[0].pingjia_yijian
          this.reply_content = vueData.gd_reply
          switch (vueData.msg.content[0].gd_state) {
            case '0':
              this.content.state = '待分配'
              this.steps = 'first'
              break
            case '1':
              this.content.state = '处理中'
              this.steps = 'first'
              break
            case '2':
              this.content.state = '已答复'
              this.steps = 'first'
              break
            case '3':
              this.content.state = '已结束'
              this.steps = 'three'
              break
          }
          if(vueData.msg.content[0].gd_pingjia != '0'){
            this.steps = 'four'
          }
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      backToGongdan() {
        this.$router.push('/fuwu2')
      },
      async handleFileChange () {
        let inputDOM = this.$refs.inputer;
        // 通过DOM取文件数据
        this.file  = inputDOM.files[0];


        /*this.imgPreview(this.file);*/

        if(this.file){
          this.imgnum = this.dataUrl.length +1
          this.loadingImg = true
          let formData = new window.FormData();
          formData.append('cmd', 'up_img')
          formData.append('gd_img', this.$refs.inputer.files[0])
          let {vueData, state} = await gongdanService.transformToVue('gdInfo','POST',formData)
          if(vueData.response == 200 ) {
            this.loadingImg = false
            this.dataUrl.push(vueData.img_url)
          }else {
            this.loadingImg = false
            this.$toast(vueData.msg,'fail')
          }
        }

      },
      delImg(id) {
        this.dataUrl.splice(id,1)
        this.imgnum = this.dataUrl.length
      },
      async submit() {
        let data = 'cmd=gd_add'+
          '&gd_content=' + this.reply +
          '&fujian_1=' + (this.dataUrl.length > 0 ? this.dataUrl[0] : '') +
          '&fujian_2=' + (this.dataUrl.length > 1 ? this.dataUrl[1] : '') +
          '&fujian_3=' + (this.dataUrl.length > 2 ? this.dataUrl[2] : '') +
          '&id_root=' + this.content.id
        this.dialogLoading = true
        let {vueData, state} = await gongdanService.transformToVue('gdInfo','POST',data)
        if(vueData.response == 200 ) {
          this.reply = ''
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.GongdanQuery()}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      LargeImg(url) {
        this.dialogShowImg = true
        this.showimgurl = url
      },
      async GongdanClose() {
        this.dialogChoose = false
        let data = 'cmd=gd_close'+
          '&id_root=' + this.content.id+
          '&DoneResult=' + this.radio
        this.dialogLoading = true
        let {vueData, state} = await gongdanService.transformToVue('gdInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.GongdanQuery()}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      GongdanPingjia() {
        this.steps = 'pingjia'
      },
      backToContent() {
        this.GongdanQuery()
      },
      async Pingjia() {
        let data = 'cmd=gd_pingjia'+
          '&gd_pingjia=' + this.pingjiaForm.rate +
          '&pingjia_yijian=' + this.pingjiaForm.content +
          '&id_root=' + this.content.id
        this.dialogLoading = true
        let {vueData, state} = await gongdanService.transformToVue('gdInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.GongdanQuery()}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      },
      touSu() {
        MessageBox.alert('投诉邮箱：accept@abeiyun.com', '提示信息', {
          confirmButtonText: '确定',
          lockScroll: false,
        }).catch(() => {})
      },
    }
  }
</script>
<style scoped>
  .page {
    margin-top: 45px;
    width: 100%;
    background-color: #fff;
  }
  .page-main { border: 0}
  .panel-heading { padding: 5px 0 0 0; }
  .hideleft { margin-left: 80px; }
  .input-with-select .el-input-group__prepend .el-select {
    width: 90px;
  }
  .pingjia-form .el-input,.el-select,.el-textarea {
    width: 440px;
  }
  * {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .margin-v-20 { margin: 20px 0}
  .margin-bottom-20 { margin-bottom: 20px;}
  .margin-bottom-30 { margin-bottom: 30px;}

  .step-bar {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
    float: left;
    width: 33%;
    height: 36px;
    line-height: 36px;
    font-size: 12px;
    color: #fff;
  }
  /* 父容器添加，变为3或4或5个步骤，triple是3,quadra是4，penta是5*/
  .step-bar-triple .step-bar {
    width: 33.3%;
  }
  .step-bar-quadra .step-bar {
    width: 25%;
  }
  .step-bar-penta .step-bar {
    width: 20%;
  }
  .step-bar-begin {
    padding-right: 18px;
  }
  .step-bar-center {
    padding: 0 18px;
  }
  .step-bar-end {
    padding-left: 18px;
  }
  .step-colored {
    background-color: #7fddff;
  }
  .step-prefix {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-left: -16px;
  }
  .step--current .step-prefix {
    background: url(../../assets/imgs/step_complete.png) no-repeat center;
    vertical-align: middle;
    /* 字体隐藏，由于模板中控制text-hide类比较复杂，这里使用step--current统一控制样式*/
    border: 0;
    background-color: transparent;
    color: transparent;
    font: 0/0 a;
    text-shadow: none;
  }
  .step--current.step--failed .step-prefix {
    background-image: url(../../assets/imgs/step_failed.png);
  }
  .step--current.step--dealing .step-prefix {
    background-image: url(../../assets/imgs/step_waiting.png);
  }
  .step--current .step-colored {
    background-color: #00aaff;
    color: #fff;
  }
  .step--completed .step-colored {
    background-color: #7fddff;
    color: #fff;
  }
  .step-arrow-left,
  .step-arrow-right {
    position: absolute;
    top: 0;
    border: 18px solid transparent;
    border-left-color: #7fddff;
  }
  .step-arrow-left {
    left: -8px;
    border: 18px solid #7fddff;
    border-left-color: transparent;
  }
  .step-arrow-right {
    right: -18px;
  }
  .step--current .step-arrow-left {
    border-color: #00aaff;
    border-left-color: transparent;
  }
  .step--current .step-arrow-right {
    border-left-color: #00aaff;
  }
  /* 对当前步骤之后的所有步骤设置灰色样式 */
  .step--current ~ .step-bar .step-colored {
    background-color: #f2f2f2;
    color: #636566;
  }
  .step--current ~ .step-bar .step-arrow-left {
    border-color: #f2f2f2;
    border-left-color: transparent;
  }
  .step--current ~ .step-bar .step-arrow-right {
    border-left-color: #f2f2f2;
  }

  .detail-panel {
    border: 1px solid #eee;
    background-color: #f5f9fa;
    padding: 20px;
  }
  .detail-item {
    width: 50%;
    line-height: 20px;
  }
  .detail-tier {
    margin-top: 10px;
  }

  /* 沟通记录 */
  .talk-container-head {
    height: 36px;
    border-bottom: 1px solid #eee;
    background-color: #f5f9fa;
    padding-left: 20px;
    line-height: 36px;
    font-size: 14px;
  }
  .talk-container-head > a {
    margin-right: 30px;
    font-weight: 400;
    font-size: 12px;
    color: #636566;
  }
  .talk-container-head > a:hover {
    text-decoration: none;
  }
  .talk-container-head > a .filter-icon {
    margin-left: 6px;
  }
  .talk-item,
  .talk-content {
    width: 100%;
  }
  .talk-item {
    padding: 30px 25px;
  }
  .talk-user-img {
    width: 50px;
    height: 50px;
  }
  .talk-user-img.user-record,
  .talk-user-img.official-record {
    float: left;
    padding-right: 0 !important;
    background-size: cover;
  }
  .talk-problem {
    float: left;
    padding-left: 20px;
    padding-top: 8px;
  }
  .talk-problem h4 {
    font-size: 12px;
    font-weight: bold;
    color: #555;
  }
  .staff-member.talk-item h4 {
    color: #00aaff;
  }
  .talk-problem-text {
    margin: 10px 0;
    font-size: 12px;
    color: #999999;
  }
  .staff-member.talk-item .talk-problem-text {
    color: #555;
  }
  .talk-time {
    float: right;
    font-size: 12px;
    color: #999;
  }
  .staff-member.talk-item {
    background-color: #f0faff;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
  }
  .workorder-attachment-container .attachment-item {
    width: 90px;
    height: 90px;
  }
  /*.attachment-container {
    float: left;
    position: relative;
    width: 130px;
    height: 90px;
    border: 1px solid #d9dcde;
    background: url(img/attachment-icon.png) no-repeat center center;
  }*/
  .attachment-container > a {
    position: absolute;
    left: -1px;
    bottom: -30px;
    width: 131px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #00aaff;
    border: 1px solid  #00aaff;
  }
  .attachment-container > a:hover {
    text-decoration: none;
  }
  .attachment-container-tips {
    padding-top: 12px;
    padding-left: 68px;
  }
  .talk-btn {
    margin-top: 30px;
    margin-left: 70px;
  }
  /* 对话框 */
  .talk-record-box {
    padding: 20px 30px;
    font-size: 14px;
  }
  .talk-content-row {
    word-break: break-all;
    line-height: 22px;
  }
  .talk-record {
    max-width: 80%;
    min-height: 80px;
    margin-bottom: 20px;
    background-repeat: no-repeat;
  }
  .user-record {
    float: right;
    padding-right: 100px;
    background: url(../../assets/imgs/avatar_talk_user_new.png) no-repeat right top;
  }
  .user-record .talk-user {
    text-align: right;
  }
  .talk-content {
    display: inline-block;
    position: relative;
    z-index: 1;
    border-radius: 2px;
    margin-top: 10px;
  }
  .talk-content .talk-record-img {
    max-width: 100%;
    max-height: 300px;
  }
  .talk-content .service-img {
    width: 100px;
    height: 100px;
  }
  .official-record {
    background: url(../../assets/imgs/avatar_talk_system_new.png) no-repeat center center;
  }


  .talk-attachments {
    margin-top: 10px;
  }
  .talk-attachments img {
    width: 120px;
    height: 90px;
    margin-right: 10px;
    background-color: #fff;
  }
  /*回复工单*/
  .textarea-container {
    padding-left: 10px;
    overflow: hidden;
  }
  .talk-textarea {
    width: 100%;
    padding: 15px 20px;
    resize: none;
    outline: none;
    border: 1px solid #d9dcde;
    line-height: 2em;
  }
  .talk-textarea::-webkit-input-placeholder {
    font-size: 12px;
    color: #666;
   }
  .textarea-desc {
    font-size: 12px;
    color: #999;
  }
  .textarea-desc .ny-checkbox {
    margin-top: 10px;
    margin-left: 20px;
  }

  /*图片上传*/
  .col-img-container .col-img {
    height: 102px;
  }
  .col-img {
    border: solid 1px #bbbaba;
    float: left;
    display: inline-block;
    overflow: hidden;
    position: relative;
    z-index: 1;
    margin-right: 10px;
  }
  .choose-file {
    display: inline-block;
    position: absolute;
    padding: 4px 12px;
    margin-bottom: 0;
    font-size: 13px;
    line-height: 18px;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    color: #fff;
    border-color: #2082dd;
    background-color: #2a89e0;
    border-radius: 2px;
  }

  .attachment-uploading:after {
    background: #f5f5f5 url(../../assets/imgs/loading.gif) no-repeat center;
  }
  .attachment-uploading:after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
  }
  .delete-attachment{
    position: absolute;
    bottom: -20px;
    left: 0;
    right: 0;
    z-index: 110;
    height: 20px;
    line-height: 20px;
    color: #fff;
    background: #000;
    opacity: 0.5;
    filter: alpha(opacity=50);
  }
  .delete-attachment:hover {
    text-decoration: none;
    color: #fff;
    opacity: 0.7;
    filter: alpha(opacity=70);
  }
  .default-transition {
    -webkit-transition-duration: 0.3s;
    -moz-transition-duration: 0.3s;
    -ms-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -webkit-transition-timing-function: ease;
    -moz-transition-timing-function: ease;
    -ms-transition-timing-function: ease;
    -o-transition-timing-function: ease;
    transition-timing-function: ease;
  }
  .attachment-done:hover .delete-attachment {
    bottom: 0;
  }
  .attachment-uploading:hover .delete-attachment {
    bottom: -20px;
  }
  .attachment-uploading img {
    visibility: hidden;
  }
</style>




// WEBPACK FOOTER //
// src/pages/fuwu/fuwu3.vue